import React, { useEffect, useState, useRef } from "react";
import { withNamespaces } from "react-i18next";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import Select from "react-select";
import showNotification from "../../../../helpers/show_notification";
import preloader from "../../../../helpers/preloader";
import printDiv from "../../../../helpers/print_data";


const EquipmentOrdersInProcess = (props) => {

  const { SearchBar } = Search;
  useEffect(() => {
    loadAllStores();
    loadAllCategories();
  }, []);
  const [confirmClose, setConfirmClose] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");

  const [centralAvailableStatus, setCentralAvailableStatus] = useState(true);
  const [isDispatched, setIsDispatched] = useState(false);

  useEffect(() => {
    loadAllOrders();
  }, [selectedCategory, selectedBranch]);

  const [allOrders, setAllOrders] = useState([]);
  const loadAllOrders = async () => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "equipmentorders/getall";
    const response = await postSubmitForm(url, {
      status: [
        "Approved",
        "Dispatched",
        "Partially Dispatched",
        "Delivered",
        "Partially Delivered",
      ],
      branch: selectedBranch,
      category: selectedCategory,
    });
    if (response && response.status === 1) {
      // let expandedRows = [];
      // response.data.map((item) => {
      //   expandedRows.push(item._id);
      // });
      preloader(false);
      setAllOrders(response.data);
      // setExpanded(expandedRowsetAllOrderss);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };
  const refForForm = useRef(null);
  const refSelectItem = useRef(null);
  const [equipmentsForOrder, setItemsForOrder] = useState([]);
  const [allStores, setAllStores] = useState([]);
  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter((store) => store.type !== "CENTRAL STORE" &&
        store.type !== "CENTRAL KITCHEN STORE" &&
        store.type !== "EQUIPMENT STORE"
      )
      setAllStores(res);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [allCategories, setAllCategories] = useState([]);
  const loadAllCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "equipmentcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
     {
      text: props.t("Equipment"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    // {
    //   dataField: "available",
    //   text: props.t("Available"),
    //   formatter: (cell, row) => {
    //     return row.available + " " + row.unit
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "15%" };
    //   },
    // },
    {
      dataField: "quantity",
      text: props.t("Order Qty."),
      formatter: (cell, row) => {
        return row.quantity + " " + row.unit
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "equipmentstore_available",
      text: props.t("Eq. Store Avl. Qty."),
      formatter: (cell, row) => {
        return row.equipmentstore_available + " " + row.unit
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "is_rented",
      text: props.t("Rented"),
      formatter: (cell, row) => {
        return row.is_rented ? "Yes" : "No"
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "rental_days",
      text: props.t("Rental Days"),
      formatter: (cell, row) => {
        return row.is_rented ? row.rental_days : " "
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
  const [selectedOrder, setSelectedOrder] = useState();
  const handleCloseOrder = async () => {
    let url = process.env.REACT_APP_BASEURL + "equipmentorders/set_closed";
    const response = await postSubmitForm(url, {
      equipmentorder_id: selectedOrder._id,
      admin_remarks: adminRemarks,
    });

    if (response && response.status === 1) {
      setAdminRemarks("");
      loadAllOrders();
      setRemarksModal(!remarksModal);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [remarksModal, setRemarksModal] = useState();
  const [adminRemarks, setAdminRemarks] = useState();
  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),

      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "branch_details.name",
      text: props.t("Store Name"),

      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Order Date"),
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },

      dataField: "createdAt",
      // formatter: (cell, row) => {
      //   return moment(row.createdAt).format("DD-MM-YYYY HH:mm");
      // },
      style: { cursor: "pointer" },
    },
    {
      dataField: "status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
            <button
              class="btn btn-secondary btn-sm mr-2"
              onClick={() => {
                setSelectedOrder(row);
                setEquipmentsForDelivery([]);
                setSelectedEquipment();
                setSelectedBatch();
                loadEquipmentsInOrder(row._id);
                setOrderDispatchModal(!orderDispatchModal);
                if (row.status === "Approved") {
                  setIsPartialDelivery(false);
                  handleSetEquipmentsForFullDelivery(row.equipment_details);
                } else setIsPartialDelivery(true);
                setCentralAvailableStatus(row.equipmentstore_available_status);
                setIsDispatched(false);
              }}
            >
              {props.t("Dispatch")}
            </button>
            <button
              class="btn btn-danger btn-sm mr-2"
              onClick={() => {
                setRemarksModal(!remarksModal);
                setSelectedOrder(row);
              }}
            >
              {props.t("Close")}
            </button>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
  ];
  const handleSetEquipmentsForFullDelivery = async (equipments) => {
    if (equipments.length > 0) {
      let new_arr = equipments.map((equip) => {
        let obj = {
          equipment_id: equip.equipment_id,
          name: equip.name,
          unit: equip.unit,
          category: equip.category,
          sub_category: equip.sub_category,
          is_rented:equip.is_rented,
          rental_days: Number(equip.rental_days),
          delivered_quantity: equip.quantity,
          equipmentstore_available: equip.equipmentstore_available,
          brand: equip.brand,
        };
        return obj;
      });
      setEquipmentsForDelivery(new_arr);
    } else {
      setEquipmentsForDelivery([]);
    }
  };
  const columns_fulldelivery = [
    {
      dataField: "equipment_id",
      hidden: true,
    },
    {
      text: props.t("Equipment"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Delivered Qty."),
      formatter: (cell, row) => {
        return row.delivered_quantity && row.delivered_quantity + " " + row.unit
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

 
  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={row.equipment_details}
          columns={columns}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
  };
  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Dispatched") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Partially Delivered") {
      style.backgroundColor = "#bb87cc";
    } else {
      style.backgroundColor = "#fffbb8";
    }
    return style;
  };

  //#region Dispatch order related code
  const [equipmentsForDelivery, setEquipmentsForDelivery] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState();
  const [orderDispatchModal, setOrderDispatchModal] = useState();
  const [equipmentBatches, setEquipmentBatches] = useState();
  const [selectedBatch, setSelectedBatch] = useState();

  const [allEquipments, setAllEquipments] = useState([]);
  const loadEquipmentsInOrder = async (equipmentorder_id) => {
    let url = process.env.REACT_APP_BASEURL + "equipmentorders/get_equipments_in_order";
    const response = await postSubmitForm(url, { equipmentorder_id });
    if (response && response.status === 1) {
      setAllEquipments(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const loadBatches = async (equipment_details) => {
    let url =
      process.env.REACT_APP_BASEURL + "storeequipmentinventories/get_for_delivery";
    const response = await postSubmitForm(url, {
      equipment_id: equipment_details.value,
    });
    if (response && response.status === 1) {
      setEquipmentBatches(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  function deleteFormatter(cell, row, rowIndex, extraData) {
    return (
      <span className="text-danger">
        <i
          className="bx bxs-trash font-size-15"
          title="Click to Delete"
          style={{ cursor: "pointer" }}
          onClick={() => {
            // console.log(row);
            let arr = extraData.filter((item) => item.batch !== row.batch);
            setEquipmentsForDelivery(arr);
          }}
        ></i>
      </span>
    );
  }
  const columns_equipments = [
    {
      text: props.t("Equipment"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Delivered Qty."),
      formatter: (cell, row) => {
        return row.delivered_quantity + " " + row.unit
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "is_rented",
      text: props.t("Rented"),
      formatter: (cell, row) => {
        return   row.is_rented ? "Yes" : "No"
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "rental_days",
      text: props.t("Rental Days"),
      formatter: (cell, row) => {
        return   row.is_rented ? row.rental_days : " "
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "",
      text: props.t("Remove"),
      formatter: deleteFormatter,
      formatExtraData: equipmentsForDelivery,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
  ];

  const columns_delivered_equipments = [
    {
      text: props.t("Equipment"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
     {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Del. Qty."),
      formatter: (cell, row) => {
        return row.delivered_quantity + " " + row.unit
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "received_quantity",
      text: props.t("Rec. Qty."),
      formatter: (cell, row) => {
        return row.received_quantity && row.received_quantity + " " + row.unit
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      text: props.t("Received?"),
      dataField: "is_received",
      formatter: (cell, row) => {
        return row.is_received ? "Yes" : "No";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const handleDispatchOrder = async () => {
    if (isDispatched) {
      return showNotification("Already dispatched.", "Error");
    }

    const invalidQuantities = equipmentsForDelivery.filter(item => {
      const orderedEquipment = selectedOrder.equipment_details.find(
        eq => eq.equipment_id === item.equipment_id
      );
      return item.delivered_quantity > orderedEquipment.equipmentstore_available;
    });

    if (invalidQuantities.length > 0) {
      const errorMessage = invalidQuantities.map(item => {
        const orderedEquipment = selectedOrder.equipment_details.find(
          eq => eq.equipment_id === item.equipment_id
        );
        return `• <strong>${item.name}</strong>: Trying to deliver <strong>${item.delivered_quantity}</strong> ${item.unit}, but only <strong>${orderedEquipment.equipmentstore_available}</strong> ${item.unit} available in Equipment Store.`;
      }).join('<br/>');

      showNotification(
        `The following items exceed available quantities:<br/>${errorMessage}`,
        "Warning"
      );
      return;
    }

    setIsDispatched(true);

      if (equipmentsForDelivery.length > 0) {
        let isPartialDelivery = false;

for (const orderedItem of selectedOrder.equipment_details) {
  const equipmentId = orderedItem.equipment_id;
  const orderedQty = orderedItem.quantity || 0;


  const previouslyDeliveredQty = (selectedOrder?.delivery_details || [])
    .filter(d => d.equipment_id === equipmentId)
    .reduce((sum, d) => sum + (d.delivered_quantity || 0), 0);

  
  const currentDispatch = equipmentsForDelivery.find(e => e.equipment_id === equipmentId);
  const currentQty = currentDispatch ? currentDispatch.delivered_quantity || 0 : 0;

  const totalAfterDispatch = previouslyDeliveredQty + currentQty;

  if (totalAfterDispatch < orderedQty) {
    isPartialDelivery = true;
    break;
  }
}

      let data_to_send = {
        equipmentorder_id: selectedOrder._id,
        branch_id: selectedOrder.branch_details?._id,
        delivery_details: equipmentsForDelivery.map(({ equipmentstore_available, ...item }) => ({
          ...item,
          is_rented: item.is_rented || false,
          rental_days: item.rental_days || 0
        })),
        isPartialDelivery
      };

      let url = process.env.REACT_APP_BASEURL + "equipmentorders/dispatch";
      const response = await postSubmitForm(url, data_to_send);
      
      if (response && response.status === 1) {
        loadAllOrders();
        showNotification(response.message, "Success");
        setOrderDispatchModal(!orderDispatchModal);
      } else {
        setIsDispatched(false);
        showNotification(response.message, "Error");
      }
    } else {
      setIsDispatched(false);
      showNotification("Add at least one item.", "Error");
    }
  };
  //#endregion

  const [isPartialDelivery, setIsPartialDelivery] = useState(false);

  const [quantity, setQuantity] = useState(0)
  const [rentalDays, setRentalDays] = useState(0);
  const [confirmDurationModal, setConfirmDuartionModal] = useState(false);
  const [is_rented, setIs_Rented] = useState(false);
    const handleAddEquipment = async (e, v) => {
    var new_array_equip = JSON.parse(JSON.stringify(equipmentsForDelivery));
    const existing_equipment = new_array_equip.filter(function (prod) {
      return prod.equipment_id === selectedEquipment._id;
    });

    if (existing_equipment.length > 0) {
      showNotification(
        props.t("This equipment is already added."),
        props.t("Warning")
      );
    } else if (selectedEquipment) {
      const orderedEquipment = selectedOrder.equipment_details.find(
        eq => eq.equipment_id === selectedEquipment._id
      );

      if (+quantity > +orderedEquipment?.equipmentstore_available) {
        showNotification(
          `Cannot add <strong>${selectedEquipment.name}</strong>. Trying to deliver <strong>${quantity}</strong> ${selectedEquipment.unit}, but only <strong>${orderedEquipment.equipmentstore_available}</strong> ${selectedEquipment.unit} available in Equipment Store.`,
          "Warning"
        );
        return;
      }

      let equipment_to_add = {
        equipment_id: selectedEquipment?._id,
        batch: selectedBatch?.value,
        unit: selectedEquipment.unit,
        name: selectedEquipment.name,
        category: selectedEquipment.category,
        sub_category: selectedEquipment.sub_category,
        brand: selectedEquipment.brand,
        delivered_quantity: +quantity
      };

      if (rentalDays > 0) {
        equipment_to_add.is_rented = true;
        equipment_to_add.rental_days = +rentalDays;
      } else {
        equipment_to_add.is_rented = false;
      }

      setEquipmentsForDelivery([...equipmentsForDelivery, equipment_to_add]);
      setSelectedEquipment();
      setIs_Rented(false);
      setQuantity(0);
      setRentalDays(0);
      setConfirmDuartionModal(false);
      setSelectedBatch();
      setEquipmentBatches([]);
      refForForm.current.reset();
    } else {
      showNotification(props.t("Select a product batch first."), props.t("Error"));
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Equipments")}
            title={props.t("Equipment Store")}
            breadcrumbItem1={props.t("Orders")}
            breadcrumbItem2={props.t("Orders In Process")}
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Orders In Process")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all orders in process here")}
                  </CardSubtitle>

                  <ToolkitProvider
                    keyField="_id"
                    data={allOrders && allOrders}
                    columns={columns_external}
                    noDataIndication={props.t("No data to display.")}
                    bootstrap4
                    search
                  >
                    {(props_table) => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={4}>
                              <Label>{props.t("Search")}</Label>
                              <SearchBar
                                {...props_table.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <AvField
                                name="branch"
                                label={props.t("Store")}
                                type="select"
                                value={selectedBranch}
                                onChange={(e) => {
                                  setSelectedBranch(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allStores &&
                                  allStores.map((branch) => {
                                    return (
                                      <option value={branch._id}>
                                        {branch.name}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                            <Col lg={4}>
                              <AvField
                                name="category"
                                label={props.t("Category")}
                                type="select"
                                value={selectedCategory}
                                onChange={(e) => {
                                  setSelectedCategory(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allCategories &&
                                  allCategories.map((category) => {
                                    return (
                                      <option value={category.category}>
                                        {category.category}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          striped
                          hover
                          condensed
                          expandRow={expandRow}
                          rowStyle={rowStyle}
                          {...props_table.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                  <Modal
                    size="xl"
                    // style={{ width: "925px", minWidth: "925px" }}
                    isOpen={orderDispatchModal}
                    toggle={() => setOrderDispatchModal(!orderDispatchModal)}
                  >
                    <ModalHeader
                      toggle={() => setOrderDispatchModal(!orderDispatchModal)}
                    >
                      {props.t("Dispatch Order")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12}>
                                    <Link
                                      to="#"
                                      onClick={() => {
                                        printDiv("printOrdered");
                                      }}
                                      className="btn btn-sm btn-success mr-2"
                                    >
                                      <i className="fa fa-print"></i> Print
                                    </Link>
                                    <div id="printOrdered">
                                      <Col lg={12} md={12}>
                                        <Label>Ordered Equipments</Label>
                                      </Col>

                                      <Col lg={12}>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          data={
                                            selectedOrder &&
                                            selectedOrder.equipment_details
                                          }
                                          columns={columns}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />

                                        <hr />
                                      </Col>
                                    </div>
                                  </Col>

                                  {selectedOrder &&
                                    selectedOrder.status === "Approved" ? (
                                    <Col lg={12}>
                                      <div class="form-check">
                                        <input
                                          type="checkbox"
                                          name="isPartialDelivery"
                                          id="isPartialDelivery"
                                          className="is-untouched is-pristine av-valid form-check-input"
                                          checked={isPartialDelivery}
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              setIsPartialDelivery(true);
                                              setEquipmentsForDelivery([]);
                                            } else {
                                              handleSetEquipmentsForFullDelivery(
                                                selectedOrder.equipment_details
                                              );
                                              setIsPartialDelivery(false);
                                            }
                                          }}
                                        />
                                        <label for="isPartialDelivery">
                                          {" "}
                                          {props.t("Partial Delivery")}
                                        </label>
                                      </div>

                                      <br />
                                    </Col>
                                  ) : null}
                                  {selectedOrder &&
                                    selectedOrder.delivery_details &&
                                    selectedOrder.delivery_details.length > 0 ? (
                                    <>
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          printDiv("printDispatched");
                                        }}
                                        className="btn btn-sm btn-success mr-2"
                                      >
                                        <i className="fa fa-print"></i> Print
                                      </Link>
                                      <div id="printDispatched">
                                        <Col lg={12} md={12}>
                                          <Label>
                                            <b>
                                              {props.t("Dispatched Equipments")}{" "}
                                            </b>
                                          </Label>
                                        </Col>
                                        <Col lg={12} className="mb-4">
                                          <BootstrapTable
                                            bootstrap4
                                            keyField="_id"
                                            data={
                                              selectedOrder.delivery_details
                                            }
                                            columns={columns_delivered_equipments}
                                            noDataIndication="No data to display."
                                            striped
                                            hover
                                            condensed
                                          />
                                          <hr />
                                        </Col>
                                      </div>
                                    </>
                                  ) : null}
                                </Row>
                                   {isPartialDelivery &&  selectedOrder?.status !== "Dispatched" && selectedOrder?.status !== "Closed" && (
                                  <Col lg={12}>
                                    <AvForm
                                    onValidSubmit={()=>setIs_Rented(true)}
                                    ref={refForForm}
                                    >
                                      <Row>
                                        <Col lg={4}>
                                          <Label>{props.t("Add Equipment")}</Label>
                                          <Select
                                            value={selectedEquipment && selectedEquipment}
                                            key={selectedEquipment}
                                            placeholder={props.t("Select...")}
                                            onChange={(e) => {
                                              setSelectedEquipment(e);
                                              loadBatches(e);
                                              setSelectedBatch();
                                            }}
                                            options={allEquipments}
                                            classNamePrefix="select2-selection"
                                            required
                                          />
                                        </Col>
                                        <Col lg={3}>
                                          <Label>{props.t("Batch")}</Label>
                                          <Select
                                            // ref={refSelectedBatch}
                                            value={selectedBatch && selectedBatch}
                                            key={selectedBatch}
                                            onChange={(e) => { setSelectedBatch(e) }}
                                            options={equipmentBatches && equipmentBatches}
                                            classNamePrefix="select2-selection"
                                            required
                                          />
                                        </Col>


                                        {selectedEquipment && (
                                          <>
                                            <Col lg={3}>
                                              <Label>
                                                {props.t("Quantity")}
                                                {selectedEquipment
                                                  ? " (in " + selectedEquipment.unit + ")"
                                                  : ""}
                                              </Label>

                                              <AvField
                                                name="quantity"
                                                placeholder={props.t("Enter Quantity")}
                                                errorMessage="Quantity cannot be empty."
                                                type="number"
                                                value={quantity}
                                                onChange={(e) => setQuantity(e.target.value)}
                                                validate={{
                                                 required: { 
                                                    value: true,
                                                    errorMessage: props.t("Quantity cannot be empty")
                                                  },
                                                  pattern: {
                                                    value: "^[0-9]+$",
                                                    errorMessage: props.t(
                                                      "Only numbers are allowed."
                                                    ),
                                                  },
                                                 max: {
                                                value: selectedBatch?.quantity || 0, 
                                                errorMessage: props.t(
                                                  `Cannot dispatch more than ${selectedBatch?.quantity} ${selectedBatch?.unit}`
                                                )
                                              },
                                                   min: {
                                                  value: 1,
                                                  errorMessage: props.t(
                                                    `Minimum quantity should be 1 ${selectedEquipment?.unit}`
                                                  )
                                                },
                                                }}
                                              />
                                            </Col>

                                            <Col lg={2} className="mb-4">
                                              <Label>&nbsp;</Label>
                                              <br />
                                              <Button
                                                type="submit"
                                                color="primary"
                                                className="btn btn-info waves-effect waves-light btn-sm"
                                              >
                                                <i className="bx bx-add-to-queue"></i>{" "}
                                                {props.t("Add")}
                                              </Button>
                                            </Col>
                                          </>
                                        )}
                                      </Row>
                                    </AvForm>
                                  </Col>
                                )}
                                <Row>
                                  {equipmentsForDelivery && equipmentsForDelivery.length > 0 && 
                                  selectedOrder?.status !== "Dispatched" && selectedOrder?.status !== "Closed" ? (
                                    <>
                                      <Col lg={12} md={12}>
                                        <br />
                                        <Label>
                                          <b>{props.t("Equipments to Dispatch")} </b>
                                        </Label>
                                      </Col>
                                      <Col lg={12}>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          key="name"
                                          data={
                                            equipmentsForDelivery && equipmentsForDelivery
                                          }
                                          columns={
                                            isPartialDelivery
                                              ? columns_equipments
                                              : columns_fulldelivery
                                          }
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                      </Col>

                                          <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          onClick={handleDispatchOrder}
                                          color="primary"
                                          className="mr-1"
                                          style={{width:'100px'}}
                                          disabled={
                                            !centralAvailableStatus ||
                                            isDispatched
                                          }
                                        >
                                          {centralAvailableStatus &&
                                            centralAvailableStatus
                                            ? isDispatched ? <Spinner size={"sm"}/> :  "Submit"
                                            : "Not enough stock at store"}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                    </>
                                  ) : null}
                              
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>

                  {/* Remarks Modal */}
                  <Modal
                    size="md"
                    isOpen={remarksModal}
                    toggle={() => setRemarksModal(!remarksModal)}
                  >
                    <ModalHeader toggle={() => setRemarksModal(!remarksModal)}>
                      Order ID: {selectedOrder && selectedOrder.order_id}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <AvForm
                                  onValidSubmit={(e, v) =>
                                    setConfirmClose(true)
                                  }
                                >
                                  <Row>
                                    <Col lg={12}>
                                      <AvField
                                        name="admin_remarks"
                                        placeholder="Enter remarks"
                                        type="textarea"
                                        onChange={(e) =>
                                          setAdminRemarks(e.target.value)
                                        }
                                        value={adminRemarks}
                                        label="Remarks"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage:
                                              "Remarks cannot be empty.",
                                          },
                                        }}
                                      />
                                    </Col>

                                    <Col lg={12}>
                                      <hr />
                                      <FormGroup className="mb-0 text-center">
                                        <div>
                                          <Button
                                            type="submit"
                                            color="primary"
                                            className="mr-1"
                                          >
                                            {props.t("Submit")}
                                          </Button>{" "}
                                        </div>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </AvForm>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>

                  {/* Close Order */}
                  {confirmClose && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmClose(false);
                        handleCloseOrder();
                      }}
                      onCancel={() => {
                        setConfirmClose(false);
                      }}
                    >
                      {props.t(
                        "Once you close this order, it cannot be revoked."
                      )}
                    </SweetAlert>
                  )}

                  {is_rented && (
                    <SweetAlert
                      title={props.t("Is Equipment Temporary ?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setIs_Rented(false);
                        setConfirmDuartionModal(true);
                      }}
                      onCancel={() => {
                        setIs_Rented(false);
                        handleAddEquipment()

                      }}
                    >
                      {/* {props.t(
                              "Once you reject this order, it cannot be revoked."
                            )} */}
                    </SweetAlert>
                  )}
                  <Modal
                    size="md"
                    isOpen={confirmDurationModal}
                    onClosed={() => {
                      setIs_Rented(false);
                      setQuantity(0);
                      setRentalDays(0)
                    }}
                    toggle={() => {
                      setConfirmDuartionModal(!confirmDurationModal)
                      setIs_Rented(false);
                      setQuantity(0);
                      setRentalDays(0)
                    }}
                  >
                    <ModalHeader toggle={() => setConfirmDuartionModal(!confirmDurationModal)}>
                      {props.t("Enter Duartion in days")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddEquipment()
                                }}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="duration"
                                      onChange={(e) => {
                                        setRentalDays(e.target.value);
                                      }}
                                      label={props.t("Days")}
                                      placeholder={props.t("Enter days")}
                                      type="number"
                                      validate={{
                                        required: { value: true },
                                      }}
                                      errorMessage="Days cannot be empty."
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Submit")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>


                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(EquipmentOrdersInProcess))
);
